module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zM4 16a11.96 11.96 0 0 1 3.5-8.462c.004 3.97.506 5.47 2.5 7.462 2 2 5 5.5 5 9.5 0 1.758.482 3 1.024 3.5H16C9.382 28 4 22.618 4 16zm16.296 11.202c1.582-1.816 3.452-4.706 2.204-7.202-2-4-9-1-9-5S20 16 20 8c0-2.876-2.298-3.796-4.692-3.978.23-.014.46-.022.692-.022 6.618 0 12 5.382 12 12 0 5.102-3.204 9.468-7.704 11.202z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/earth-1.js
// module id = 1123
// module chunks = 14